export const userProfile = {
  username: "Username",
  myProfile: "My Profile",
  myCompany: "My Company",
  detailedDescription: "Detailed Description",
  myAccount: "My Account",
  uploadPhoto: "Upload Photo",
  deleteProfile: "Delete Profile?",
  areYouSureDeleteProfile:
    "Are you sure you want to delete your profile? This action cannot be undone. All your data will be deleted and you will not be able to recover it.",
  profileDeletedSuccessfully: "Profile deleted successfully",
  errorDeletingProfile: "Error deleting profile. Please try again.",
  contactInfo: "Contact Information",
  personalInfo: "Personal Information",
  mobilePhone: "Mobile Phone",
  assignedRoles: "Assigned roles",
  telephone: "Telephone",
  marketplacePreferences: "Marketplace preferences",
  personalDetailsFromSignIn: "These details come from your sign-in profile.",
  preferencesDescription:
    "Language, currency, and theme are stored for your marketplace account.",
  notProvided: "Not provided",
  notSet: "Not set",
  theme: "Theme",
  profileManagedByKeycloak:
    "Language, currency, and theme are stored for your marketplace account. Personal details above come from your sign-in profile.",
  preferencesViewOnly: "View only — edit to change",
  preferencesSaveHint: "Save to keep your marketplace preference changes.",
  // ===============================================================
};
